import React from 'react';

function TablePreview({ data }) {
  if (!data?.columns?.length) return null;
  return (
    <div style={{ overflowX: 'auto' }}>
      <p style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 10 }}>
        Showing {data.rows?.length || 0} of {data.totalRows?.toLocaleString() || '?'} rows
      </p>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', overflow: 'hidden' }}>
        <thead>
          <tr style={{ background: 'var(--surface2)' }}>
            {data.columns.map(col => (
              <th key={col} style={{
                padding: '7px 12px', textAlign: 'left', fontFamily: 'Space Mono', fontWeight: 700,
                color: 'var(--text-2)', fontSize: 11, borderBottom: '1px solid var(--border)',
                whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.04em',
              }}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(data.rows || []).map((row, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? 'var(--surface)' : 'var(--surface2)', borderBottom: '1px solid var(--border)' }}>
              {(Array.isArray(row) ? row : [row]).map((cell, j) => (
                <td key={j} style={{
                  padding: '6px 12px', color: 'var(--text)', fontFamily: 'Space Mono',
                  fontSize: 11, whiteSpace: 'nowrap', maxWidth: 200,
                  overflow: 'hidden', textOverflow: 'ellipsis',
                }}>
                  {cell == null ? <span style={{ color: 'var(--text-3)' }}>null</span> : String(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function AssetPreview({ asset }) {
  if (!asset) return null;
  const { assetType, previewSampleData, previewText, modelMeta } = asset;

  if (assetType === 'dataset' && previewSampleData?.columns?.length) {
    return <TablePreview data={previewSampleData} />;
  }

  if (previewText) {
    return (
      <pre style={{
        background: 'var(--surface2)', padding: 18, borderRadius: 'var(--radius-sm)',
        color: 'var(--text)', fontFamily: 'Space Mono', fontSize: 12,
        overflowX: 'auto', whiteSpace: 'pre-wrap', lineHeight: 1.7,
        border: '1px solid var(--border)',
      }}>
        {previewText}
      </pre>
    );
  }

  if (modelMeta) {
    const entries = Object.entries(modelMeta).filter(([, v]) => v);
    if (!entries.length) return <p style={{ color: 'var(--text-3)', fontSize: 14 }}>No metadata available.</p>;
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        {entries.map(([k, v]) => (
          <div key={k} className="card" style={{ padding: '10px 14px' }}>
            <div style={{ fontSize: 10, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 3 }}>{k}</div>
            <div style={{ fontSize: 13, color: 'var(--text)', fontFamily: 'Space Mono' }}>{v}</div>
          </div>
        ))}
      </div>
    );
  }

  return <p style={{ color: 'var(--text-3)', fontSize: 14 }}>No preview available.</p>;
}
